import { Section as ContainerComponent } from '../features/layouts';

/**
 * @deprecated Use Section from '@connected/ui/features/layouts' instead
 * @see {@link file://packages/ui/src/features/layouts/components/section.tsx}
 *
 * @example
 * // Old usage:
 * import { Container } from '@connected/ui/layouts/container';
 *
 * // New usage:
 * import { Section } from '@connected/ui/features/layouts';
 */
export const Container = ContainerComponent;
